import { Component, OnInit } from '@angular/core';

import { environment } from '../../../../environments/environment';
import * as alerts from '../../_functions/alerts';
import { FidelidadeService } from '../../_services/fidelidade.service';

import { Clipboard } from '@angular/cdk/clipboard';
import { Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { LocalStorageUtils } from 'src/app/utils/localstorage';

@Component({
  selector: 'app-indicacoes',
  templateUrl: './indicacoes.component.html',
  styleUrls: ['./indicacoes.component.scss'],
  providers: [],
})
export class IndicacoesComponent implements OnInit {
  // constantes
  private readonly LINK_WHATSAPP: string =
    'https://api.whatsapp.com/send?text=';
  private readonly ADICIONAR_TAG: string = 'add';
  private readonly TEMPLATE_ID: string = '17ccfbdf-a100-43d7-bf39-c19f346c38aa';

  public readonly PAGE_HOME: string = 'home';
  public readonly PAGE_PARCEIROS: string = 'cadastro_parceiros';

  indicacoes: any = undefined;
  membro: any = undefined;
  emails: string[] = [];
  emailsEmpresa: string[] = [];

  public tags: any[] = ['welcome', 'to', 'ngx-tags-input'];

  // variaveis privadas
  private idEncryptado: any = undefined;
  private textoIndicacao: string = '';
  private textoIndicacaoEmpresa: string = '';

  // variaveis de controle
  collapseAberto: boolean = false;
  collapseAbertoEmpresa: boolean = false;
  exibeMensagemEmailObrigatorio: boolean = false;
  exibeMensagemEmailEmpresaObrigatorio: boolean = false;
  btnDisabled: boolean = false;
  btnDisabledEmpresa: false;

  private localStorage:LocalStorageUtils;

  constructor(
    private fidelidadeService: FidelidadeService,
    private clipboard: Clipboard,
    private router: Router,
    private authService: AuthService
  ) 
  {
    this.localStorage = new LocalStorageUtils();
  }

  ngOnInit(): void {
    this.obterMembro();
  }

  copiarLink(page: string) {
    var link = this.obterLink(page);
    this.clipboard.copy(link);
    this.localStorage.salvarLinkIndicacao(link);

    alerts.exibirToast('success', 'Link copiado com sucesso!', 'top-right');
  }

  controlePainel(): void {
    this.collapseAberto = !this.collapseAberto;
  }

  controlePainelEmpresa(): void {
    this.collapseAbertoEmpresa = !this.collapseAbertoEmpresa;
  }

  enviarLinkWhats(page: string) {
    window.open(
      this.LINK_WHATSAPP + this.obterTextoIndicacaoELink(page),
      '_blank'
    );
  }

  displayTags(event: any) {
    if (this.emails.length != 0) {
      this.exibeMensagemEmailObrigatorio = false;
    }
    if (event.change == this.ADICIONAR_TAG) {
      this.emails.push(event);
    } else {
      this.emails = this.emails.filter(function (item) {
        return item !== event.tag.displayValue;
      });
    }
  }

  onTagsCompanyChanged(event: any) {
    if (event.change == this.ADICIONAR_TAG)
      this.emailsEmpresa.push(event.tag.displayValue);
    else {
      this.emailsEmpresa = this.emailsEmpresa.filter(function (item) {
        return item !== event.tag.displayValue;
      });
    }
  }

  enviarEmail(page: string) {
    let emailsComErro = 0;
    let emailErrados: string[] = [];
    this.emails.forEach((email) => {
      if (!email.includes('@')) {
        emailsComErro = emailsComErro + 1;
        emailErrados.push(email);
        return;
      }
    });

    if (emailsComErro > 0) {
      alerts.exibirToast(
        'error',
        emailErrados.length > 1
          ? `Os emails ${emailErrados} estão no formato incorreto!`
          : `O email ${emailErrados} está no formato incorreto!`,
        'top-right'
      );
      return;
    }

    if (this.emails.length == 0) {
      this.exibeMensagemEmailObrigatorio = true;
      return;
    }

    this.btnDisabled = true;
    this.exibeMensagemEmailObrigatorio = false;

    this.fidelidadeService
      .enviarEmailIndicacao(
        this.obterRequestEnvioDeEmailMarketingCloud(page)
      )
      .subscribe({
        next: (res: any) => {
          this.btnDisabled = false;
          alerts.exibirToast('success', 'Email enviado com sucesso!');
          this.exibeMensagemEmailObrigatorio = false;
          this.emails = [];
        },
        error: (err: any) => {
          this.btnDisabled = false;
          console.error('Erro ao enviar e-mail(s)...', err);
        },
      });
  }

  irParaPaginaCadastro(): void {
    this.router.navigate([`/${this.PAGE_PARCEIROS}`], {
      queryParams: { hashIndicacao: this.idEncryptado },
    });
  }

  private obterRequestEnvioDeEmail(): any {
    var emailsSendRequest: any[] = [];

    this.emails.forEach((element) => {
      emailsSendRequest.push({
        to: element,
        substitutions: {
          '{link}': this.obterLink(this.PAGE_HOME),
        },
      });
    });

    let request = {
      from: 'contato@cacaulovers.com',
      subject: 'Venha ser um Membro Cacau Lovers o/',
      from_name: 'Cacau Show',
      template_id: this.TEMPLATE_ID,
      idConta: '980e8d5f-04b2-4b29-8d9d-3f9da8503240',
      authToken: '120b5367-bed8-4468-8bac-2b31ebe320d4',
      messages: emailsSendRequest,
    };

    return request;
  }

  private obterRequestEnvioDeEmailMarketingCloud(page: string): any {
    var emailsSendRequest: any[] = [];

    this.emails.forEach((element) => {
      emailsSendRequest.push({
          definitionKey: "transacional_indicacao",
          subscriberKey: element,
          emailAddress: "contato@cacaulovers.com",
          nome: this.membro.nome,
          link: this.obterLink(page),
          tipo: "Indicacao_Amigo",
          cpf: this.membro.cpf,
          messageKey: encodeURIComponent(this.idEncryptado)
      });
    });

    let request = emailsSendRequest;

    return request;
  }

  private obterRequestEnvioDeEmaiEmpresa(): any {
    var emailsSendRequest: any[] = [];

    this.emails.forEach((element) => {
      emailsSendRequest.push({
        to: element,
        substitutions: {
          '{link}': this.obterLink(this.PAGE_PARCEIROS),
        },
      });
    });

    let request = {
      from: 'contato@cacaulovers.com',
      subject: 'Venha ser um Parceiro Cacau Lovers o/',
      from_name: 'Cacau Show',
      template_id: this.TEMPLATE_ID,
      idConta: '980e8d5f-04b2-4b29-8d9d-3f9da8503240',
      authToken: '120b5367-bed8-4468-8bac-2b31ebe320d4',
      messages: emailsSendRequest,
    };

    return request;
  }

  private obterMembro() {
    var membro = this.authService.LocalStorage.obterMembro();
    this.processarSucessoObterMembro(membro);
  }

  private processarSucessoObterMembro(res: any) {
    this.membro = res;
    if (this.membro.tipoStatus === 7 || this.membro.tipoStatus === 11) {
      this.router.navigate(['/meusdados']);
    }
    this.obterEncrypt();
    this.obterIndicacoes();
  }

  private obterIndicacoes() {
    this.fidelidadeService.obterIndicacoes(this.membro.id).subscribe({
      next: (res: any) => (this.indicacoes = res),
      error: (err: any) => console.error('Erro ao obter indicacoes...', err),
    });
  }

  private obterEncrypt() {
    this.fidelidadeService.obterTextoEncryptado(this.membro.id).subscribe({
      next: (res: any) => {
        this.idEncryptado = res.resultado;
        this.obterTextoIndicacao();
        this.obterTextoIndicacaoEmpresa();
      },
      error: (err: any) =>
        console.error('Erro ao obter id encryptado:...', err),
    });
  }

  private obterTextoIndicacao() {
    this.fidelidadeService
      .obterConfiguracaoPorDescricao('DescricaoMsgIndicacao')
      .subscribe({
        next: (res: any) => (this.textoIndicacao = res.valor),
        error: (err: any) =>
          console.error('Erro ao tentar obter texto de indicação...', err),
      });
  }

  private obterTextoIndicacaoEmpresa() {
    this.fidelidadeService
      .obterConfiguracaoPorDescricao('DescricaoMsgIndicacaoEmpresa')
      .subscribe({
        next: (res: any) => (this.textoIndicacaoEmpresa = res.valor),
        error: (err: any) =>
          console.error('Erro ao tentar obter texto de indicação...', err),
      });
  }

  private obterLink(page: string): string {
    return (
      environment.urlPageLovers +
      page +
      '?hashIndicacao=' +
      encodeURIComponent(this.idEncryptado)
    );
  }

  private obterTextoIndicacaoELink(page: string): string {
    if (page == this.PAGE_HOME)
      return this.textoIndicacao + ' ' + this.obterLink(page);
    else return this.textoIndicacaoEmpresa + ' ' + this.obterLink(page);
  }
}
